import {Room} from '../Room';
import {NotificationBase} from './NotificationBase';

export class Mention extends NotificationBase {

	public isPrivate: boolean = false;
	public rid: string = '';

	public constructor(obj?: Record<string, unknown>) {
		super();
		Object.assign(this, obj);
	}

	set(room: Room) {
		this.isPrivate = room.isPrivate;
		this.rid = <string> room.uuid;
	}
}
